import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export default function TypingTest() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ background: '#000000' }}>
      <nav className="px-6 py-4 border-b border-gray-800">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-gray-400 hover:text-white transition-colors">
            <Home className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold text-white">Typing Test</h1>
        </div>
      </nav>
      
      <div className="max-w-4xl mx-auto px-8 py-12">
        <div className="stat-card rounded-2xl p-8 border">
          <h2 className="text-3xl font-bold text-white mb-6">Typing Speed Test</h2>
          <p className="text-gray-400 text-lg leading-relaxed mb-6">
            Test your typing speed with our advanced typing test. Choose from different durations and difficulty levels to challenge yourself.
          </p>
          <p className="text-gray-400 mb-8">
            This feature is currently under development. Please use the Practice page to improve your typing skills.
          </p>
          <Link to="/" className="btn-primary inline-block">
            Go to Practice
          </Link>
        </div>
      </div>
    </div>
  )
}
